import DOMPurify from "dompurify";
import linkifyHtml from "linkify-html";


export function useHtmlUtil() {
  function formatText(text: string): string {
    if (!text) {
      return ''
    }

    const sanitizedText = DOMPurify.sanitize(text, {
      ALLOWED_TAGS: [],
      ALLOWED_ATTR: []
    })

    const linkedText = linkifyHtml(sanitizedText, {
      target: '_blank',
      rel: 'noopener noreferrer'
    })

    return linkedText
  }

  return {
    formatText
  }
}
